import AuthComponent from '../Auth';
import SecuredMain from './secured-main';
import NonSecuredMain from './non-secured-main';


export default AuthComponent( SecuredMain, NonSecuredMain )